<template>
  <span v-tooltip="tooltip" class="tax-label" v-if="Number.isFinite(tax)">
    <font-awesome-icon icon="info-circle"/> <template v-if="hasText">Including Taxes</template>
  </span>
</template>

<script>
/**
   * Show more information about the final price (tax).
   * @version 1.0.0
   * @since 2.1.0
   * @deprecated 3.9.1 Replaced with VSubtotalInfo.
   */
export default {
  props: {
    tax: {
      required: true,
    },
    priceBeforeTax: {
      type: Number,
      required: true,
    },
    priceAfterTax: {
      type: Number,
      required: true,
    },
    deliveryFee: {
      type: Number,
      required: true,
    },
    hasText: {
      type: Boolean,
      required: false,
      default: true,
    },
    currency: {
      type: Object,
      required: false,
      default: null,
    },
  },
  computed: {
    taxFee() {
      return this.priceBeforeTax * this.tax / 100;
    },
    content() {
      return `
      <div class="tax">
        <div class="tax__item">
          <strong class="tax__label">Subtotal:</strong>
          <span class="tax__number">
            ${this.$helpers.formatPrice(this.priceBeforeTax, this.currency)}
          </span>
        </div>
        <div class="tax__item">
          <strong class="tax__label">Delivery Fee:</strong>
          <span class="tax__number">
            +${this.$helpers.formatPrice(this.deliveryFee, this.currency)}
          </span>
        </div>
        <div class="tax__item">
          <strong class="tax__label">Tax (${this.tax}%):</strong>
          <span class="tax__number">
            +${this.$helpers.formatPrice(this.taxFee, this.currency)}
          </span>
        </div>
        <div class="tax__item tax__item--total">
          <strong class="tax__label">Total:</strong>
          <span class="tax__number">
            ${this.$helpers.formatPrice(this.priceAfterTax, this.currency)}
          </span>
        </div>
      </div>
`;
    },
    tooltip() {
      return {
        html: true,
        placement: 'top-end',
        classes: ['tooltip-general'],
        content: this.content,
      };
    },
  },
};
</script>

<style lang="scss">
.tax-label {
  cursor: pointer;
  color: #6C7995;
  @include font-size(12px);
  font-weight: 600
}

.tax {
  min-width: 164px;
  &__item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 6px;

    &--total {
      padding-top: 6px;
      border-top: 1px solid rgba(#fff, .2);
    }
  }
}
</style>
